"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _useShoppingCartContent = _interopRequireDefault(require("@sprinx/react-shopping-cart/useShoppingCartContent"));

var _ShoppingContext = _interopRequireDefault(require("../ShoppingProvider/ShoppingContext"));

var _useViesValidate = _interopRequireDefault(require("./useViesValidate"));

//
var useEffectRecalculateCartOnChange = function useEffectRecalculateCartOnChange(nextVal) {
  var _useShoppingCartConte = (0, _useShoppingCartContent.default)(),
      _useShoppingCartConte2 = (0, _slicedToArray2.default)(_useShoppingCartConte, 2),
      cart = _useShoppingCartConte2[0],
      setSubject = _useShoppingCartConte2[1];

  var _ref = cart.subjects[0] || {},
      product = _ref.product,
      quantity = _ref.quantity;

  var _React$useState = _react.default.useState(nextVal),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      val = _React$useState2[0],
      setVal = _React$useState2[1];

  _react.default.useEffect(function () {
    if (val !== nextVal) {
      setVal(nextVal);

      if (quantity) {
        setSubject({
          product: product,
          quantity: quantity
        });
      }
    }
  }, [product, quantity, val, nextVal, setSubject]);
};

function ViesHandler(_ref2) {
  var useTest = _ref2.useTest,
      viesInvoiceCountry = _ref2.viesInvoiceCountry;
  var validateVies = (0, _useViesValidate.default)({
    useTest: useTest,
    viesInvoiceCountry: viesInvoiceCountry
  });

  var _React$useContext = _react.default.useContext(_ShoppingContext.default),
      checkoutState = _React$useContext.checkoutState,
      noTaxPrices = _React$useContext.noTaxPrices,
      updateContext = _React$useContext.updateContext;

  var _ref3 = checkoutState || {},
      invoiceCompany = _ref3.invoiceCompany,
      invoiceInfo = _ref3.invoiceInfo,
      invoiceToCompany = _ref3.invoiceToCompany;

  var _ref4 = invoiceCompany || {},
      taxNo = _ref4.taxNo;

  var _ref5 = invoiceInfo || {},
      country = _ref5.country;

  var _React$useState3 = _react.default.useState({}),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      _React$useState4$ = _React$useState4[0],
      viesCountry = _React$useState4$.country,
      isCompany = _React$useState4$.isCompany,
      isValid = _React$useState4$.isValid,
      viesTaxNo = _React$useState4$.taxNo,
      setState = _React$useState4[1]; // TODO: move to ShoppingProvider


  useEffectRecalculateCartOnChange(noTaxPrices);

  _react.default.useEffect(function () {
    if (taxNo !== viesTaxNo || country !== viesCountry || isCompany !== invoiceToCompany) {
      if (taxNo && invoiceToCompany) {
        validateVies(taxNo, country).then(function (v) {
          setState({
            isValid: v,
            taxNo: taxNo,
            country: country,
            isCompany: invoiceToCompany
          });
          updateContext({
            viesValid: v
          });
        });
      } else if (isValid || viesTaxNo || !invoiceToCompany) {
        setState({
          isValid: false,
          taxNo: taxNo,
          country: country,
          isCompany: invoiceToCompany
        });
        updateContext({
          viesValid: false
        });
      }
    }
  }, [country, invoiceToCompany, isCompany, isValid, taxNo, updateContext, validateVies, viesCountry, viesTaxNo]);

  return null;
}

var _default = ViesHandler;
exports.default = _default;